<div class="workSpace">
  <div class="sk-graf-wrapper">

    <div class="sk-graf-header">
      <ngx-skeleton-loader [theme]="{ 'border-radius': '10px', height: '14px', width: '150px', margin: '0' }" />
    </div>

    <div class="sk-filas">
      @for(b of barrasArray; track $index) {
        <div class="sk-fila">

          <!-- etiqueta izquierda -->
          <ngx-skeleton-loader [theme]="{
            'border-radius': '10px',
            height: '11px',
            width: '80px',
            'animation-delay': getDelay($index),
            margin: '0'
          }" />

          <!-- track + barra -->
          <div class="sk-track">
            <ngx-skeleton-loader [theme]="{
              'border-radius': '6px 0 0 6px',
              height: '22px',
              width: getAltura($index) + '%',
              'animation-delay': getDelay($index),
              margin: '0'
            }" />
          </div>

        </div>
      }
    </div>

    <div class="sk-leyenda">
      @for(l of leyendasArray; track $index) {
        <div class="sk-leyenda-item">
          <ngx-skeleton-loader [theme]="{ 'border-radius': '50%', height: '10px', width: '10px', margin: '0' }" />
          <ngx-skeleton-loader [theme]="{ 'border-radius': '10px', height: '10px', width: '70px', margin: '0' }" />
        </div>
      }
    </div>

  </div>
</div>